import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../data/site";

export default function Services() {
  return (
    <section
      id="services"
      className="py-20 md:py-28 bg-white"
      data-testid="services-section"
    >
      <div className="container">
        <div className="grid lg:grid-cols-12 gap-6 items-end mb-12">
          <div className="lg:col-span-7">
            <p className="text-overline text-electric mb-3">01 — Services</p>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-charcoal text-balance">
              Digital Marketing Services That Drive Real Revenue
            </h2>
          </div>
          <p className="lg:col-span-5 text-zinc-500 text-lg leading-relaxed">
            Six core services, tightly coordinated — from AI Search and SEO to
            Paid Ads, Social Media, and Email Marketing, all working together
            toward one goal: your growth.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, idx) => {
            const Icon = s.icon;
            const dark = s.accent;
            return (
              <motion.article
                key={s.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: idx * 0.05 }}
                className={`group relative p-7 md:p-9 rounded-2xl border transition-all duration-300 ${s.span ?? ""} ${
                  dark
                    ? "bg-charcoal text-white border-charcoal-700 hover:shadow-glow-brand"
                    : "bg-white text-charcoal border-zinc-100 shadow-card hover:shadow-card-hover hover:-translate-y-1"
                }`}
                data-testid={`service-card-${s.slug}`}
              >
                <div className="flex items-start justify-between">
                  <div
                    className={`w-12 h-12 grid place-items-center rounded-xl ${
                      dark
                        ? "bg-white/10 border border-white/15"
                        : "bg-electric/8 border border-electric/15"
                    } group-hover:bg-electric group-hover:border-electric transition-colors`}
                  >
                    <Icon
                      className={`w-5 h-5 ${dark ? "text-electric-400" : "text-electric"} group-hover:text-white`}
                      strokeWidth={2}
                    />
                  </div>
                  <ArrowUpRight
                    className={`w-5 h-5 opacity-30 group-hover:opacity-100 transition-all group-hover:translate-x-0.5 group-hover:-translate-y-0.5 ${
                      dark ? "text-white" : "text-charcoal"
                    }`}
                  />
                </div>
                <h3 className="font-display text-xl md:text-2xl font-semibold mt-8 leading-tight">
                  {s.title}
                </h3>
                <p
                  className={`mt-3 text-[15px] leading-relaxed ${
                    dark ? "text-zinc-400" : "text-zinc-500"
                  } group-hover:text-zinc-300`}
                >
                  {s.description}
                </p>
                <ul className="mt-6 flex flex-wrap gap-2">
                  {s.bullets.map((b) => (
                    <li
                      key={b}
                      className={`text-xs px-3 py-1 rounded-full border ${
                        dark
                          ? "border-white/15 text-zinc-300"
                          : "border-zinc-200 text-zinc-500"
                      }`}
                    >
                      {b}
                    </li>
                  ))}
                </ul>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
